import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import arabicTranslations from './ar.js';
import arCustomerManagement from './ar-customerManagement.js';
import arTransactionsPage from './ar-transactions.js';
import arRewardsManagement from './arRewardsManagement.js';

// Create English translations (can start with a subset of keys as you build out)
const englishTranslations = {
  app: {
    title: 'Loyalty Program Dashboard',
    version: 'Version 1.0.0',
  },
  nav: {
    dashboard: 'Dashboard',
    customers: 'Customers',
    transactions: 'Transactions',
    rewards: 'Rewards',
    settings: 'Settings',
  },
  // Add more as needed...
};

const arMerged = {
  ...arabicTranslations,
  ...arCustomerManagement,
  ...arTransactionsPage,
  ...arRewardsManagement
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: englishTranslations
      },
      ar: {
        translation: arMerged
      }
    },
    fallbackLng: 'ar',
    lng: 'ar',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false // not needed for React
    }
  });

export default i18n;